
import Vue from 'vue'

import Loader from '~/components/Loader.vue'
import { blockScroll, enableScroll } from '~/plugins/helper'

export default Vue.extend({
  name: 'Loading',
  components: {
    Loader
  },
  data() {
    return {
      loading: true
    }
  },
  methods: {
    start() {
      this.loading = true
      document.body.classList.add('block')
      blockScroll()
    },

    finish() {
      document.body.classList.remove('block')
      document.body.classList.add('ready')
      enableScroll()
      this.loading = false
    }
  }
})
